import { ValidationMessageProvider } from './validation-message-provider';

export class ValidationConfig<T> {
  public specification: object | null = null;
  public additionalRules: object | null = null;
  public warnings: ValidationSeveritySetting[] | null = null;
  public notifications: ValidationSeveritySetting[] | null = null;
  public messageProvider: ValidationMessageProvider<T> | null = null;
}

export interface ValidationSeveritySetting {
  path: string;
  code: string;
}
